import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { TranslocoModule } from "@jsverse/transloco";

import { LorenUserSettingsComponent } from "./components/loren-user-settings/loren-user-settings.component";
import { LorenUserSettingsRoutingModule } from "./loren-user-settings-routing.module";
import { LorenCardModule } from "../../shared/modules/loren-card/loren-card.module";
import { LorenImageModule } from "../../shared/pipes/loren-image/loren-image.module";
import { LorenPageContentComponent } from "../../shared/modules/loren-page-content/loren-page-content.component";
import {MatCardTitle} from "@angular/material/card";

@NgModule({
  declarations: [LorenUserSettingsComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatListModule,
        MatSlideToggleModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinner,
        TranslocoModule,
        LorenUserSettingsRoutingModule,
        LorenCardModule,
        LorenImageModule,
        LorenPageContentComponent,
        MatCardTitle
    ],
})
export class LorenUserSettingsModule {}
